import React from 'react';
import { Link } from 'react-router-dom';
import {default as MyButton} from '../../../components/Button';
import Input from '../../../components/Form/Input';
import Select from '../../../components/Form/Select';
import useForm from '../../../hooks/useForm';
import { api } from '../../../services/api';
import { UserContext } from '../../../UserContext';
import {
    LoginContainer,
    Form,   
    FormDiv,
    Flex,
    Submit
} from '../Main/styled';
import { Button } from '@material-ui/core';
import {useNavigate} from 'react-router-dom';
import { useParams } from 'react-router';
import {createStyles, makeStyles, Theme, withStyles} from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import { red } from '@material-ui/core/colors';
import { CteProps, TranportadoraProp } from '../../../interfaces';
import Alert from '../../../components/Alert';
import Modal from '../../../components/Modal';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginBottom: 10,
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
        button: {
            marginRight: 20,            
        },
        step: {
            backgroundColor: 'transparent'
        },
    }),
);

const ColorButton = withStyles((theme: Theme) => ({
    root: {
      color: theme.palette.getContrastText(red[500]),
      backgroundColor: red[500],
      borderRadius: 10,
      '&:hover': {
        backgroundColor: red[700],
      },
    },
}))(Button);

const Cte: React.FC = () => {
    document.title = "Controle de Frete - Sultan Veste a Casa";

    const {setLoading} = React.useContext(UserContext);

    const [transportadoras, setTranportadoras] = React.useState<Array<any>>([]);
    const [cte, setCte] = React.useState<CteProps>();
    const [error, setError] = React.useState("");
    const [openConfirm, setOpenConfirm] = React.useState(false);

    const key_cte = useForm();
    const transportadora = useForm();

    const navigate = useNavigate();
    const param = useParams();
    const classes = useStyles();   

    React.useEffect(() => {
        getTransportadoras();

        if(param.pk){
            getCte(param.pk)
        }
        // eslint-disable-next-line
    }, []);

    const getCte = async (pk: string) => {
        try{
            setLoading(true);

            const {data} = await api.get(`/frete/document/${param.pk}`);

            key_cte.setValue(data.documento.sChaveCTe);
            transportadora.setValue(data.documento['infe.dbo.Transportadora']);
            
            setCte(data.documento);
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
        }
    }

    const getTransportadoras = async () => {
        try{            
            setLoading(true);

            const {data} = await api.get('/transportadora');

            const options = data.transportadoras.map((item : TranportadoraProp) => {
                return {
                    id: item.PKTransp,
                    description: item.sNomeTransp + ' - ' + item.sCNPJ
                }
            });

            setTranportadoras(options);
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
        }
    }

    const onSave = async (e: React.FormEvent) => {
        e.preventDefault();

        try{
            setLoading(true);

            const {data} = await api.post('/frete/document/save', {
                Tipo: 1,
                PKTransportadora: transportadora.value,
                ChaveCTe: key_cte.value,       
                PKControleDeFrete: param.pk ? cte?.PK : -1,
                TimeStamp: param.pk ? cte?.TimeStamp : 1,
                Action2Do:  param.pk ? 2 : 1            
            });

            if(data.document.PKControleDeFreteCadastrado){
                navigate(`${process.env.PUBLIC_URL}/usuario/controle-de-frete/anexar/1/${transportadora.value}/${data.document.PKControleDeFreteCadastrado}`);           
            }
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
        }
    }

    const handleMessageError = () => {
        setError("");
    }

    const handleOpen = () => {
        setOpenConfirm(true);
    }

    const handleCloseConfirm = () => {
        setOpenConfirm(false);
    }

    const handleClickDelete = async () => {
        try{
            setLoading(true);
            
            await api.post('/frete/document/save', {
                Tipo: 1,
                PKTransportadora: transportadora.value,
                ChaveCTe: key_cte.value,       
                PKControleDeFrete: cte?.PK,
                TimeStamp: cte?.TimeStamp,
                Action2Do: 3
            });

            navigate(`${process.env.PUBLIC_URL}/usuario/controle-de-frete/`);           
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
            handleCloseConfirm();
        }
    }

    return (
        <LoginContainer>            
            <Flex>
                <FormDiv>
                    <Form onSubmit={onSave} className="shadow">                                        
                        <h2 className="centro">CTE</h2>
                        <Select disabled={param.pk ? true : false} label="Tranportadora: *" required
                                id="segment" {...transportadora} options={transportadoras}/>
                        <Input 
                            label="Chave de Acesso do CTE: *" 
                            required
                            placeholder="Chave de Acesso"
                            autoComplete="off"
                            id="key_cte" 
                            type="text" {...key_cte}
                            disabled={param.pk ? true : false}
                        />
                        <Submit>
                            <Link to={!param.pk ? `${process.env.PUBLIC_URL}/usuario/controle-de-frete/opcoes` : `${process.env.PUBLIC_URL}/usuario/controle-de-frete`}>Voltar</Link>
                            <div className="ds-flex">
                                {param.pk &&
                                    <ColorButton
                                        variant="contained"
                                        color="secondary"
                                        size="large"
                                        className={classes.button}
                                        startIcon={<DeleteIcon />}
                                        onClick={handleOpen}
                                    >
                                        EXCLUIR
                                    </ColorButton> 
                                }                                
                                <MyButton>
                                    Confirmar
                                </MyButton>
                            </div>                            
                        </Submit>                           
                    </Form>                                                                                             
                </FormDiv>
            </Flex> 

            <Modal
                open={openConfirm} 
                onClose={handleCloseConfirm} 
                onConfirm={handleClickDelete} 
                titleModal={"Excluir Documento"}
                message={"Você está prestar a Excluir um documento! Tem certeza que deseja continuar com essa ação ?"}
            />

            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>                    
        </LoginContainer>
    );
};

export default Cte;